import L from 'leaflet';

/**
 * @license https://github.com/pointhi/leaflet-color-markers
 * Copyright (c) 2010-2019, Vladimir Agafonkin
 * Copyright (c) 2010-2011, CloudMade
 * Copyright (c) 2013-2020, Thomas Pointhuber
 * All rights reserved.
 */

// importを使うとリリースビルド時になぜか上記のライセンス表示が
// LICENSE.txtに載らないため、仕方なくrequireで宣言
const redIconUrl = require('../../images/marker-icon-2x-red.png');
const blueIconUrl = require('../../images/marker-icon-2x-blue.png');
const yellowIconUrl = require('../../images/marker-icon-2x-gold.png');
const blackIconUrl = require('../../images/marker-icon-2x-black.png');
const shadowUrl = require('../../images/marker-shadow.png');

export const redIcon = new L.Icon({
  iconUrl: redIconUrl,
  shadowUrl: shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
export const blueIcon = new L.Icon({
  iconUrl: blueIconUrl,
  shadowUrl: shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
export const yellowIcon = new L.Icon({
  iconUrl: yellowIconUrl,
  shadowUrl: shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
export const blackIcon = new L.Icon({
  iconUrl: blackIconUrl,
  shadowUrl: shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
